module.exports = __webpack_public_path__ + "img/eight7Blue.fd28e406.jpg";